export default defineNuxtPlugin(() => {
  const route = useRoute()
  const isLoading = useState('loading', () => {
    // 接入代碼不用loading
    const getType = route.query.type || ''
    return getType !== 'popup'
  })

  return {
    provide: {
      startLoading: () => (isLoading.value = true),
      stopLoading: () => (isLoading.value = false)
    }
  }
})
